import { render, staticRenderFns } from "./set-test.vue?vue&type=template&id=2b77144d&scoped=true"
import script from "./set-test.vue?vue&type=script&lang=ts"
export * from "./set-test.vue?vue&type=script&lang=ts"
import style0 from "./set-test.vue?vue&type=style&index=0&id=2b77144d&prod&lang=scss"
import style1 from "./set-test.vue?vue&type=style&index=1&id=2b77144d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77144d",
  null
  
)

export default component.exports